import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_VEHICLE_URL;

//#region Model

// GET request
export function GetTypes(
  // clientId: string,
  queryParams?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes`, "GET", queryParams);
}

// GET request
export function GetTypeById(vehicleTypeId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes/${vehicleTypeId}`, "GET");
}

// POST request
export function AddType(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes`, "POST", body);
}

// PUT request
export function UpdateType(
  customerId: string,
  body?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes/${customerId}`, "PUT", body);
}

// DELETE request
export function DeleteType(modelId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes/${modelId}`, "DELETE");
}

// PATCH request
export function PatchType(modelId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}VehicleTypes/${modelId}`, "PATCH");
}

// POST request
export function AddTypeImage(
  vehicleTypeId: number,
  body?: any
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}VehicleTypes/${vehicleTypeId}/image`,
    "POST",
    body
  );
}

//#endregion Model
